import { apiClient } from "../apiClient";

const SINH_VIEN_DANG_KY_THUC_TAP_ENDPOINT = 'sinh-vien-dang-ky-thuc-tap';
export const sinhVienDangKyThucTapApi = {
    SelectByDotThucTap: (id_dot_thuc_tap: number) => apiClient.get(`${SINH_VIEN_DANG_KY_THUC_TAP_ENDPOINT}/dot-thuc-tap/${id_dot_thuc_tap}`),
}